const baseUrl = process.env.DOCCEN_API_URL;

export const uploadFilesEndpoint = `${baseUrl}/api/v1/upload/files`;
export const uploadApplicationEndpoint = `${baseUrl}/api/v1/upload/applications`;
